
import { mapMutations, mapGetters } from 'vuex';
import CallIcon from '@/components/svg/mobile/CallIcon.vue';

import header from '~/mixins/header';

export default {
    mixins: [header],
    components: { CallIcon },
    props: ['localeName'],
    mounted() {
        const initUserTheme = this.getTheme() || this.getMainTheme?.replace(/_/, '-');
        this.setTheme(initUserTheme);

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            this.forceRepaint();
        }
    },
    data() {
        return {
            userTheme: 'light-theme',
        };
    },
    computed: {
        otherLangCode() {
            return this.$i18n.locales.filter(i => i.code !== this.$i18n.locale)[0].code;
        },
        ...mapGetters(['getShowNavigationMobile']),
        ...mapGetters({
            isNovaPorta: 'global/getIsNovaPorta',
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            isOpen: 'auth/isOpen',
            isAuth: 'auth/isAuth',
            mainPhoneNumber: 'global/mainPhoneNumber',
        }),
        isClient() {
            return process.client;
        },
    },
    methods: {
        ...mapMutations(['setShowNavigationMobile']),
        ...mapMutations('search', ['setModalShow']),
        logout() {
            this.$store.dispatch('auth/logout');
        },
        openCall() {
            window.open(`tel:${this.mainPhoneNumber?.replace(/\s/g, '')}`, '_self');
        },
        openModalAuth() {
            this.$store.dispatch('auth/setIsOpen', true);
        },
        toggleMenu() {
            this.setShowNavigationMobile(!this.getShowNavigationMobile);
        },
        toggleThemeMobile() {
            const activeTheme = this.$cookies.get('user-theme');
            if (activeTheme === 'light-theme') {
                this.setTheme('dark-theme');
            } else {
                this.setTheme('light-theme');
            }

            this.forceRepaint();
        },

        getTheme() {
            const savedTheme = this.$cookies.get('user-theme');

            const isDarkTheme = document.body.classList.contains('dark-theme');

            if (savedTheme) {
                return savedTheme;
            } else {
                if (isDarkTheme) {
                    return 'dark-theme';
                }
                return 'light-theme';
            }
        },
        setTheme(name) {
            this.userTheme = name;

            if (name === 'light-theme') {
                document.body.classList.remove('dark-theme');
                document.body.classList.add('light-theme');
                this.$cookies.set('user-theme', 'light-theme');
            } else if (name === 'dark-theme') {
                document.body.classList.remove('light-theme');
                document.body.classList.add('dark-theme');
                this.$cookies.set('user-theme', 'dark-theme');
            }

            this.forceRepaint();
        },
        forceRepaint() {
            document.body.style.display = 'none';
            document.body.offsetHeight;
            document.body.style.display = '';
        },
    },
};
